import VariantWrapper from './VariantWrapper';
import type { ActivityEntry } from '../ActivityChapter.interface';
import SectionHeader from '../SectionHeader';
import type { AssetType } from '../../../../../utils/storage';
import ActivityMedia from './BackgroundMedia';
import { ABSOLUTE_FILL } from '../../../../core/animations/fast-lane-2/helpers';
import type { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface LayoutProps {
    entry: ActivityEntry;
    media?: AssetType;
    children?: ReactNode;
}

export default function Layout({ entry, children, media }: LayoutProps) {
    return (
        <VariantWrapper>
            <SectionHeader title={entry.chapter_title} />

            <div
                style={{
                    ...ABSOLUTE_FILL,
                    zIndex: -1,
                }}
            >
                <ActivityMedia media={media} />
                <motion.div
                    style={{
                        ...ABSOLUTE_FILL,
                        background: 'rgba(0,0,0,0.4)',
                    }}
                />
            </div>

            {children}
        </VariantWrapper>
    );
}
